import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import AutoSelect from '../../../containers/selects/auto_select';
import { findAllSellerByCompanyEvent } from '../../../_events/sellers/find_sellers.event';
import { message } from 'antd';

const AutoSelectSeller = (props) => {

    const { seller } = props;

    const [data, setData] = useState([]);
    
    const loadSellers = () => {
        findAllSellerByCompanyEvent()
        .then(data => {
            setData(data.list);
        })
        .catch(err => {
            message.error(err.message);
        });
    }

    useEffect(() => {
        loadSellers();
    }, []);

    return(
        <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
                <input id='client_seller' hidden defaultValue={seller ? seller.uuid : ''} />
                <AutoSelect
                    id='client_seller_autoselect'
                    label='Vendedor'
                    getOptionLabel={(option) => `${option.seller_cod}`}
                    renderOption={(props, option) => (<div {...props}>{`${option.full_name}`}</div>)}
                    data={data}
                    onChange = {(value) => {
                        document.getElementById('client_seller').value = value ? value['uuid'] : '';
                    }}
                    value={seller ? seller : null}
                />
            </Grid>
        </Grid>
    );

}

export default AutoSelectSeller;